import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { Box } from '@mui/material';
import theme from '../../theme';
import Navbar from '../Navbar';
import Footer from '../Footer';
import PricingSection from '../home/PricingSection';

// Standalone /pricing page — wraps the editorial PricingSection (which needs
// the custom theme tokens) in ThemeProvider + Navbar/Footer.
export default function PricingPage() {
  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ bgcolor: theme.home.paper, minHeight: '100vh' }}>
        <Navbar />
        <Box sx={{ pt: { xs: 4, md: 6 } }}>
          <PricingSection />
        </Box>
        <Footer />
      </Box>
    </ThemeProvider>
  );
}
